// The overall array for navigation
var navigationList = [];
var crumbList = [];
var promoBannerList = [];
var firstPath = false;
var firstPathCount = 0;
const colorOverride = theme.strings.navwordoverride;

jQuery( document ).ready( function() {
    createNavigationList();
    createPromoBannerList();
    actionContextualMenu();
    outputBreadcrumbs();

    //console.log("navigationList object :");
    //console.log(navigationList);
    //console.log("promoBannerList object :");
    //console.log(promoBannerList);
    //console.log("crumbList object :");
    //console.log(crumbList);

    if (jQuery(window). width() > 1023) {
        renderNavigationList();
        navigationHoverIeFixes();
    }
    
    collectionSameLevel();
    collectionSubCategory();
});

function createPromoBannerList() {
    jQuery( '.mobile-nav .mobile-nav__item-level-1' ).each( function() {
        let attr = jQuery(this).is("[data-nav]");
        
        if(typeof attr !== typeof undefined && attr !== false){
            let obj = jQuery(this).find('[data-banners]').data('banners');
            let promoData = {
                "obj": obj
            };

            promoBannerList.push( promoData );
        }
    });
}

function renderNavigationList() {
    let desktopMenuHtml = "";
    
    jQuery('#MasterNav').append('<ul class="site-nav list--inline" id="SiteNav"></ul>');

    //Render level 1 nodes
    for (var i = 0; i<navigationList.length; i++ ) {
        if(navigationList[i].self.levels > 0){
            //If level 1 has childrens
            desktopMenuHtml +=
            '<li class="site-nav__level-0 site-nav--has-dropdown" aria-haspopup="true">'
                +'<a href="'+navigationList[i].self.url+'" class="site-nav__link site-nav__link--main site-nav__link--button">'
                    +'<span class="site-nav__label ';
                    if (navigationList[i].self.title == colorOverride){ 
                        desktopMenuHtml +='nav-override';
                    } 
                    desktopMenuHtml +=' ">'+navigationList[i].self.title+'</span>'
                +'</a>'
                +'<div class="site-nav__dropdown site-nav__dropdown--centered" id="SiteNavLabel-'+navigationList[i].self.handle+'">';
            
                if(navigationList[i].self.levels > 1){
                    //If level 2 has childrens
                    desktopMenuHtml +=
                    '<div class="site-nav__childlist">'
                        +'<ul class="site-nav__childlist-grid" aria-label="submenu">';
                        
                        //Render level 2 nodes
                        for (var j = 0; j<navigationList[i].children.length; j++ ) {
                            desktopMenuHtml += 
                            '<li class="site-nav__childlist-item" aria-haspopup="true">'
                                +'<a href="'+navigationList[i].children[j].self.url+'" class="site-nav__link site-nav__child-link site-nav__child-link--parent">'
                                    +'<span class="site-nav__label">'+navigationList[i].children[j].self.title+'</span>'
                                +'</a>';

                                if(navigationList[i].children[j].self.levels > 0){
                                    //If level 2 has childrens
                                     desktopMenuHtml +=
                                    '<ul aria-label="submenu">'
                                        +'<li>'
                                            +'<a href="'+navigationList[i].children[j].self.url+'" class="site-nav__link site-nav__child-link site-nav__child-link--view-all">'
                                                +'<span class="site-nav__label">View all</span>'
                                            +'</a>'
                                        +'</li>';

                                        for (var k = 0; k<navigationList[i].children[j].children.length; k++ ) {
                                            desktopMenuHtml +=
                                            '<li>'
                                                +'<a href="'+navigationList[i].children[j].children[k].self.url+'" class="site-nav__link site-nav__child-link">'
                                                    +'<span class="site-nav__label">'+navigationList[i].children[j].children[k].self.title+'</span>'
                                                +'</a>'
                                            +'</li>';
                                        }

                                    desktopMenuHtml += 
                                    '</ul>';
                                }

                            desktopMenuHtml += 
                            '</li>';
                        }

                    desktopMenuHtml +=
                        '</ul>';

                        if(promoBannerList[i].obj != undefined){
                            if (promoBannerList[i].obj.banner01Condition || promoBannerList[i].obj.banner02Condition){
                                desktopMenuHtml +=
                                '<div class="site-nav__promo-banners">';
                                    if(promoBannerList[i].obj.banner01Condition){
                                        desktopMenuHtml +=
                                        '<div class="site-nav__promo-banner">'
                                            +'<a href="'+promoBannerList[i].obj.banner01Link+'">'
                                                +'<img src="'+promoBannerList[i].obj.banner01Image+'">'
                                            +'</a>'
                                        +'</div>';
                                    }
                                    if(promoBannerList[i].obj.banner02Condition){
                                        desktopMenuHtml +=
                                        '<div class="site-nav__promo-banner">'
                                            +'<a href="'+promoBannerList[i].obj.banner02Link+'">'
                                                +'<img src="'+promoBannerList[i].obj.banner02Image+'">'
                                            +'</a>'
                                        +'</div>';
                                    }
                                desktopMenuHtml +=
                                '</div>';
                            }
                        }

                    desktopMenuHtml +=
                    '</div>';
                }else{
                    if (navigationList[i].self.handle == 'brands') {
                        //Render brands panel
                        var equalCol = Math.round(navigationList[i].children.length/4);
                        desktopMenuHtml += 
                        '<div class="site-nav__childlist site-nav__brands">'
                          +'<div class="site-nav__childlist-grid" aria-label="submenu">';

                            //Render level 2 nodes
                            for (var j = 0; j<navigationList[i].children.length; j++ ) {

                                if (j%equalCol == 0) {
                                    var cap = j + equalCol - 1;
                                    desktopMenuHtml += '<ul class="site-nav__brands-col">';
                                }

                                desktopMenuHtml += 
                                '<li class="site-nav__childlist-item" aria-haspopup="true">'
                                    +'<a href="'+navigationList[i].children[j].self.url+'" class="site-nav__link site-nav__child-link site-nav__child-link--parent">'
                                        +'<span class="site-nav__label">'+navigationList[i].children[j].self.title+'</span>'
                                    +'</a>'
                                +'</li>';

                                if (j == cap) {
                                    desktopMenuHtml += '</ul>';
                                }
                            }

                        desktopMenuHtml += 
                          '</div>'
                        +'</div>';
                    } else {
                        //Just a link
                        desktopMenuHtml += 
                        '<div class="site-nav__childlist">'
                          +'<ul class="site-nav__childlist-grid" aria-label="submenu">';

                            //Render level 2 nodes
                            for (var j = 0; j<navigationList[i].children.length; j++ ) {
                                desktopMenuHtml += 
                                '<li class="site-nav__childlist-item" aria-haspopup="true">'
                                    +'<a href="'+navigationList[i].children[j].self.url+'" class="site-nav__link site-nav__child-link site-nav__child-link--parent">'
                                        +'<span class="site-nav__label">'+navigationList[i].children[j].self.title+'</span>'
                                    +'</a>'
                                +'</li>';
                            }

                        desktopMenuHtml += 
                          '</ul>'
                        +'</div>';
                    }
                }

            desktopMenuHtml +=
                '</div>'
            +'</li>';
        }else{
            //Just a link
            desktopMenuHtml +=
            '<li class="site-nav__level-0">'
                +'<a href="'+navigationList[i].self.url+'" class="site-nav__link site-nav__link--main site-nav__link--button">'
                    +'<span class="site-nav__label ';
                    if (navigationList[i].self.title == colorOverride){ 
                        desktopMenuHtml +='nav-override';
                    } 
                    desktopMenuHtml += ' ">'+navigationList[i].self.title+'</span>'
                +'</a>'
            +'</li>'
        }
    }

    if (localStorage.getItem(desktopMenuHtml) === null) {
        jQuery('#MasterNav > ul').append(desktopMenuHtml);
    }
}

function createNavigationList() {
    jQuery( '.mobile-nav > [data-nav]' ).each( function( index, element ) {
        // Retrieve the navigation object
        let self    = jQuery( this ).data( 'nav' );
        let navData = {
            "self": self
        };

        // Push breadcrumb if active or homepage
        if( (self.childActive || self.current || self.active) && !firstPath ) {
            self['pathIndex'] = index;
            crumbList.push( self );
            firstPath = !firstPath;
        }

        // Add child items to the nav object
        addNavChildren( navData, this );

        // Add objects to parent array
        navigationList.push( navData );
    });
}

function addNavChildren( navDataObject, element ) {
    let pathCount = 0;

    // Check if there are children to add
    if( jQuery( element ).find( '[data-nav]' ).length > 0 ) {

        navDataObject.children = []; 
        
        // Retrieve the first child and its immediate parent
        let firstChild = jQuery( element ).find( '[data-nav]' ).first(),
            parent     = firstChild.parent();
        
        // Iterate through immediate descendants so we only retrieve data at the appropriate level
        jQuery( parent ).find( '> [data-nav]' ).each( function() {
            let self = jQuery( this ).data( 'nav' );
            let navData  = {
                "self": self,
                "children": [] 
            };

            // Push breadcrumb if this or a child is active
            if( (self.childActive || self.current || self.active) && firstPathCount < 2 ) {
                self['pathIndex'] = pathCount;
                crumbList.push( self );
                firstPathCount++;
            }

            // Add any subchildren to the object
            addNavChildren( navData, this );
            navDataObject.children.push( navData );
            pathCount++;
        });
    }
}

function navigationHoverIeFixes() {
    jQuery( '#MasterNav .site-nav--has-dropdown' ).each( function(i, obj) {
        jQuery( this ).hover(
            function() {
                jQuery( this ).find('.site-nav__dropdown').addClass( "hover" );
            }, function() {
                jQuery( this ).find('.site-nav__dropdown').removeClass( "hover" );
            }
        );
    });
}

function outputBreadcrumbs() {
    let container = jQuery( 'nav.jsbreadcrumb ol' );

    if( crumbList.length > 0 ) {
        
        for( let index = 0; index < crumbList.length; index++ ) {
            let last   = ( index == crumbList.length - 1 );
            let link   = crumbList[ index ];
            let list   = jQuery( '<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">' );
            let crumb  = last ? jQuery( '<span itemprop="name">' ) : jQuery( '<a itemprop="item" title="'+link.title+'">' );
            let count  = index + 2;

            
            if( !last ) {
                crumb.attr( 'href', link.url );
                crumb.html( '<span itemprop="name">'+ link.title +'</span>');
            } else {
                crumb.text( link.title );
            }
            crumb.appendTo( list );
            list.append('<meta itemprop="position" content="'+ count +'" />');
            list.appendTo( container );

            if( !last ){ 
                jQuery( '<li><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right icon--full-color" width="8.121px" height="13.414px" viewBox="0 0 8.121 13.414"><g transform="translate(0.707 0.707)"><path class="st0" d="M0,12l6-6L0,0" fill="none" stroke="#24394d" stroke-width="2"/></g></svg></li>' ).appendTo( container );
            }
        }
    } else {
        var title = jQuery('.collection-header h1').text();
        if (document.querySelector('[data-breadcrumbposition]')) {
            var breadcrumbPosition = document.querySelector('[data-breadcrumbposition]').dataset.breadcrumbposition;
            jQuery( '<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><span itemprop="name">'+title+'</span><meta itemprop="position" content="'+breadcrumbPosition+'" /></li>' ).appendTo( container );
        } else {
            jQuery( '<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><span itemprop="name">'+title+'</span><meta itemprop="position" content="2" /></li>' ).appendTo( container );
        }
    }
    //console.log(crumbList);
}

function actionContextualMenu() {
    let container = jQuery( 'nav.mobile-nav-contextual' );
    
    if (container[0]) {
        if( crumbList.length > 0 ) {
            if( crumbList.length < 2 || crumbList[0].handle == "brands") {
                container.addClass('sub-nav--is-open');
                container.find('#MobileNav').addClass('is-open__level1');
                container.find('.mobile-nav__item-level-1[data-handle="'+crumbList[0].handle+'"]').addClass('is-active');
                container.find('button[data-level="1"]').addClass('is-active');
            } else {
                container.addClass('sub-nav--is-open');
                container.addClass('third-nav--is-open');
                container.find('#MobileNav').addClass('is-open__level1');
                container.find('#MobileNav').addClass('is-open__level2');
                container.find('.mobile-nav__item-level-1[data-handle="'+crumbList[0].handle+'"]').addClass('is-active');
                container.find('button[data-level="1"]').addClass('is-active');
                container.find('.mobile-nav__item-level-2[data-handle="'+crumbList[1].handle+'"]').addClass('is-active');
                container.find('button[data-level="2"]').addClass('is-active');
            }
        }
    }
}

function collectionSameLevel() {
    let sameLevelHtml = "";

    if( crumbList.length > 0 ) {
        if ( jQuery('html').find('.full-template-collection-same-level').length > 0 || jQuery('html').find('.full-template-collection-list-same-level').length > 0 || jQuery('html').find('.full-template-collection-blackfriday-same-level').length > 0 || jQuery('html').find('.template-collection #shopify-section-collection-section-seo-buttons').length > 0 ) {
            if( crumbList.length == 2 ) {
                for (var i = 0; i < navigationList[crumbList[ 0 ].pathIndex].children.length; i++ ) {
                    if( crumbList[ 1 ].pathIndex != i ){
                        sameLevelHtml +=
                        '<a href="'+navigationList[crumbList[ 0 ].pathIndex].children[i].self.url+'" class="btn btn--secondary">'
                            +navigationList[crumbList[ 0 ].pathIndex].children[i].self.title
                        +'</a>';
                    }
                }
            }

            if( crumbList.length == 3 ) {
                for (var i = 0; i < navigationList[crumbList[ 0 ].pathIndex].children[crumbList[ 1 ].pathIndex].children.length; i++ ) {
                    if( crumbList[ 2 ].pathIndex != i ){
                        sameLevelHtml +=
                        '<a href="'+navigationList[crumbList[ 0 ].pathIndex].children[crumbList[ 1 ].pathIndex].children[i].self.url+'" class="btn btn--secondary">'
                            +navigationList[crumbList[ 0 ].pathIndex].children[crumbList[ 1 ].pathIndex].children[i].self.title
                        +'</a>';
                    }
                }
            }

            if (localStorage.getItem(sameLevelHtml) === null) {
                if ( jQuery('html').find('.full-template-collection-same-level').length > 0 ) {
                    jQuery('.full-template-collection-same-level .section-header .sub-category').append(sameLevelHtml);
                }
                if ( jQuery('html').find('.full-template-collection-list-same-level').length > 0 ) {
                    jQuery('.full-template-collection-list-same-level .section-header .sub-category').append(sameLevelHtml);
                }
                if ( jQuery('html').find('.full-template-collection-blackfriday-same-level').length > 0 ) {
                    jQuery('.full-template-collection-blackfriday-same-level .section-header .sub-category').append(sameLevelHtml);
                }
                if ( jQuery('html').find('.template-collection #shopify-section-collection-section-seo-buttons').length > 0 ) {
                    jQuery('.template-collection #shopify-section-collection-section-seo-buttons .csc-button-linkblock').append(sameLevelHtml);
                }
            }
        }
    }
}

function collectionSubCategory() {
    let subCategoryHtml = "";

    if( crumbList.length > 0 ) {
        if ( jQuery('html').find('.full-template-collection-sub-category').length > 0 || jQuery('html').find('.full-template-collection-list-sub-category').length > 0 || jQuery('html').find('.full-template-collection-blackfriday-sub-category').length > 0 ) {
            if( crumbList.length == 1 ) {
                for (var i = 0; i < navigationList[crumbList[ 0 ].pathIndex].children.length; i++ ) {
                    subCategoryHtml +=
                    '<a href="'+navigationList[crumbList[ 0 ].pathIndex].children[i].self.url+'" class="btn btn--secondary btn--small">'
                        +navigationList[crumbList[ 0 ].pathIndex].children[i].self.title
                    +'</a>';
                }
            }

            if( crumbList.length == 2 ) {
                for (var i = 0; i < navigationList[crumbList[ 0 ].pathIndex].children[crumbList[ 1 ].pathIndex].children.length; i++ ) {
                    subCategoryHtml +=
                    '<a href="'+navigationList[crumbList[ 0 ].pathIndex].children[crumbList[ 1 ].pathIndex].children[i].self.url+'" class="btn btn--secondary btn--small">'
                        +navigationList[crumbList[ 0 ].pathIndex].children[crumbList[ 1 ].pathIndex].children[i].self.title
                    +'</a>';
                }
            }

            if (localStorage.getItem(subCategoryHtml) === null) {
                if ( jQuery('html').find('.full-template-collection-sub-category').length > 0 ) {
                    jQuery('.full-template-collection-sub-category .section-header .sub-category').append(subCategoryHtml);
                }
                if ( jQuery('html').find('.full-template-collection-list-sub-category').length > 0 ) {
                    jQuery('.full-template-collection-list-sub-category .section-header .sub-category').append(subCategoryHtml);
                }
                if ( jQuery('html').find('.full-template-collection-blackfriday-sub-category').length > 0 ) {
                    jQuery('.full-template-collection-blackfriday-sub-category .section-header .sub-category').append(subCategoryHtml);
                }
            }
        }
    }
}

